import * as React from "react";
import * as S from "./style";
import SendIcon from "@mui/icons-material/Send";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import { useLanguage } from '../../../contexts/LanguageContext';

interface ChatInputProps {
  conversationId: string;
  isNewConversation: boolean;
  handleSubmit: (val: any) => void;
  handleCancel: () => void;
  loading?: boolean;
}

export default function ChatInput(props: ChatInputProps) {
  const { t } = useLanguage();
  const [value, setValue] = React.useState<string>("");

  const handleSubmit = () => {
    if (props.loading) return;
    if (value.trim() !== "") {
      const entry = { role: "user", content: value };
      props.handleSubmit(entry);
      setValue("");
    }
  };

  return (
    <S.ChatInputBox id="chat-input-box">
      <S.StyledTextField
        multiline
        variant="standard"
        autoComplete="off"
        type="text"
        placeholder={t('chat.placeholder')}
        InputProps={{ disableUnderline: true }}
        value={value}
        onChange={(event: any) => setValue(event.target.value)}
        onKeyDown={(e: any) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            if (!props.loading) handleSubmit();
          }
        }}
      />

      <S.FunctionalityWrapper>
        <S.StyledIconButton
          disableFocusRipple
          disabled={(value.trim() === "" && !props.loading)}
          onClick={() =>
            props.loading ? props.handleCancel() : handleSubmit()
          }
        >
          {props.loading ? <StopCircleIcon /> : <SendIcon />}
        </S.StyledIconButton>
      </S.FunctionalityWrapper>
    </S.ChatInputBox>
  );
}
